const MAX_AXIS_LABELS = 12;

function toMonthKey(date: Date): string {
  return `${date.getFullYear()}-${date.getMonth()}`;
}

/** True when this index starts a new calendar month vs the previous point. */
export function isMonthBoundary(rawDates: unknown[], index: number): boolean {
  if (index === 0) return true;

  const current = rawDates[index];
  const previous = rawDates[index - 1];
  if (!(current instanceof Date) || !(previous instanceof Date)) {
    return index === 0;
  }

  return toMonthKey(current) !== toMonthKey(previous);
}

/**
 * ECharts category-axis interval callback: show month labels once, cap density on long ranges.
 */
export function createCategoryAxisLabelInterval(
  rawDates: unknown[],
): (index: number, value: string) => boolean {
  const boundaryIndices = rawDates.reduce<number[]>((indices, _, index) => {
    if (isMonthBoundary(rawDates, index)) {
      indices.push(index);
    }
    return indices;
  }, []);

  if (boundaryIndices.length === 0) {
    return () => true;
  }

  const shownIndices = new Set<number>();

  if (boundaryIndices.length <= MAX_AXIS_LABELS) {
    boundaryIndices.forEach((index) => shownIndices.add(index));
  } else {
    const targetCount = MAX_AXIS_LABELS;
    for (let i = 0; i < targetCount; i += 1) {
      const position =
        targetCount === 1
          ? 0
          : Math.round((i * (boundaryIndices.length - 1)) / (targetCount - 1));
      shownIndices.add(boundaryIndices[position]);
    }
  }

  return (index: number) => shownIndices.has(index);
}
